import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-map-button',
  templateUrl: './map-button.component.html',
  styleUrls: ['./map-button.component.scss'],
})
export class MapButtonComponent implements OnInit {
  @Input() btnOptions: any;
  @Input() styleButton: string;

  constructor() {}

  ngOnInit() {}
}
